export  const CHNAGE_CURRENT_SONG = "player/CHNAGE_CURRENT_SONG"
export const CHANGE_PLAY_LIST = "player/CHANGE_PLAY_LIST"
export const CHANGE_CURRENT_SONG_INDEX = "player/CHANGE_CURRENT_SONG_INDEX"
export const CHANGE_SEQUENCE = "player/CHANGE_SEQUENCE"

export const CHANGE_LYRIC_LIST = "player/CHANGE_LYRIC_LIST"
export const CHANGE_CURRENT_LYRIC_INDEX = "player/CHANGE_CURRENT_LYRIC_INDEX"

export const CHANGE_SIMI_PLAYLIST = "player/CHANGE_SIMI_PLAYLIST";
export const CHANGE_SIMI_SONGS = "player/CHANGE_SIMI_SONGS";
